@if (toast) {
  <div
    #toast
    (click)="dismiss()"
    [ngClass]="{
      successToast: notificationType === notificationTypesInTheUI.success,
      failureToast: notificationType === notificationTypesInTheUI.failure,
    }"
    id="toast"
  >
    <div class="row">
      @if (notificationType === notificationTypesInTheUI.success) {
        <div class="col-auto">
          <i class="fa fa-check fa-2x"></i>
        </div>
      }
      @if (notificationType === notificationTypesInTheUI.failure) {
        <div class="col-auto notification-padding-top">
          <i class="fa fa-circle-o fa-lg circle-position"></i>
          <i class="fa fa-exclamation exclamation-position"></i>
        </div>
      }
      @if (!messageIsHTML) {
        <div class="col notification-padding-top">
          {{ message }}
        </div>
      }
      @if (messageIsHTML) {
        <div [innerHTML]="message" class="col notification-padding-top"></div>
      }
    </div>
  </div>
}
